export default Object.freeze({
	DOMAIN: process.env.REACT_APP_API_URL,
});
